module.exports = __webpack_public_path__ + "assets/logout-white.5778fa8c.svg";